export const countyListRoute = {
  path: "/management/county",
  name: "county-list",
  component: () => import("../../ui/management/county/county-list.vue")
};